import { get } from '../../utils/api';

export const getAllPresets = async () => {
  const {
    data: { data },
  } = await get('pos/v1/preset');
  return data;
};

const output = {
  getAllPresets,
};

export default output;
